import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TransactionsComponent } from './transactions.component';
import { MomentModule } from 'ngx-moment';
import { TransactionsRoutingModule } from './transactions.routing.module';
import { DownloadService } from '../reports/download-service';
import { RefundComponent } from './refund/refund.component';
import { ViewDetailsModule } from '../view-details/view-details.module';
import { ViewReceiptsModule } from '../view-receipts/view-receipts.module';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TransactionsRoutingModule,
        MomentModule,
        ViewDetailsModule,
        ViewReceiptsModule,
        NzSelectModule,
        NzDropDownModule,
        NzTableModule,
        NzTagModule,
        NzButtonModule,
        NzGridModule,
        NzToolTipModule,
        NzPaginationModule,
        NzDatePickerModule,
        NzInputModule,
        NzIconModule,
        NzDividerModule,
        NzUploadModule,
        NzFormModule,
        NzInputNumberModule,
        NzSpinModule,
        NzTabsModule,
        NzListModule,
        NzCommentModule,
        NzAvatarModule
 
    ],
    declarations: [TransactionsComponent, RefundComponent],
    exports: [RefundComponent],
    providers: [DownloadService]
})
  export class TransactionsModule {

  }
